export function THead() {
  return (
    <thead>
      <tr>
        <th>
          <span className="d-desktop">Estação</span>
          <span className="d-mobile">Estação</span>
        </th>

        <th>
          <span className="d-desktop">Hora da Última Leitura</span>
          <span className="d-mobile" title="Hora da Última Leitura">
            Últ. Leitura
          </span>
        </th>

        <th>
          <span className="d-desktop">Precipitação Hora</span>
          <span className="d-mobile" title="Precipitação na última hora">
            Prec. Hora
          </span>
        </th>

        <th>
          <span className="d-desktop">Precipitação Dia</span>
          <span className="d-mobile" title="Precipitação acumulada no dia">
            Prec. Dia
          </span>
        </th>

        <th>
          <span className="d-desktop">Precipitação Tempestade</span>
          <span
            className="d-mobile"
            title="Precipitação acumulada na tempestade"
          >
            Prec. Temp.
          </span>
        </th>
      </tr>
    </thead>
  );
}
